<div class="modal fade" id="dialog_list_req" tabindex="-1" role="dialog" aria-labelledby="Anular" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 800px;">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">{{titulo}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0 overflow-auto" style="height: 400px;">
        <div class="row m-0">
          <div class="col-md-12 p-3">
            <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
            </lib-filtro>
          </div>
        </div>
        <div class="row m-0" *ngIf="lista && lista.length === 0">
          <div class="col-12" style="text-align: center;">
            <i class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></i>
            <span class="text-black-50 ml-1">Não foram encontrados usuários vinculado!</span>
          </div>
        </div>
        <div class="row m-0" *ngIf="lista && lista.length > 0">
          <div class="table-responsive">
            <table class="table table-eddy">
              <thead>
                <tr>
                  <th scope="col" class="text-center">Nº RRM</th>
                  <th scope="col" class="text-center">Data</th>
                  <th scope="col">Setor</th>
                  <th scope="col">Usuário</th>
                  <th scope="col" class="text-center">Status</th>
                  <th scope="col" class="text-center">Tipo</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of lista">
                  <th scope="row" class="text-center">{{item.id}}</th>
                  <td class="text-center">{{item.data_cadastro | date:'dd/MM/yyyy':'GMT'}}</td>
                  <td> {{item.setor_almoxarifado?.setor?.nome}} </td>
                  <td>{{item.usuario?.nome}}</td>
                  <td class="text-center">
                    <span class="badge"
                      [ngClass]="corStatusRequisicao(item.status)">{{tituloStatusRequisicao(item.status)}}</span>
                  </td>
                  <td class="text-center">
                    <span *ngIf="item.devolucao" class="badge badge-danger">Devolução</span>
                    <span *ngIf="!item.devolucao" class="badge badge-success">Retirada</span>
                  </td>
                  <td class="text-right">
                    <button (click)="selecionar(item)"
                      routerLinkActive="router-link-active" class="btn btn-sm btn-primary mr-2">
                      <img src="assets/img/global/pencil.png" alt="editar" height="18" width="18">
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-secondary btn-sm text-white float-left"
          data-dismiss="modal">Cancelar</button>
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
  </div>
</div>